import React, { useState } from 'react';
import {
    Box,
    Grid,
    Typography,
    Button,
    Card,
    CardContent,
    FormControl,
    Select,
    MenuItem,
    FormControlLabel,
    Checkbox,
    TextField,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { allRegion, allDriverType, allCountries, northAmericaCountries } from '../../utils/dropOptions';

function GeneralInfo({ onNext }) {
    const [info, setInfo] = useState({
        preferredRegion: '',
        driverType: '',
        fastApproved: false,
        fastNumber: '',
        fastExpiration: null,
        crossBorderDriving: false,
        bondedDriver: false,
        countryOfCitizenship: '',
        countryOfResidence: '',
        referredBy: '',
    });

    const handleChange = (field) => (event) => {
        setInfo({
            ...info,
            [field]: event.target.type === 'checkbox' ? event.target.checked : event.target.value
        });
    };

    const handleDateChange = (date) => {
        setInfo({
            ...info,
            fastExpiration: date
        });
    };

    const handleSubmit = () => {
        if (onNext) onNext(info);
    };

    return (
        <Box sx={{ maxWidth: 900, mx: 'auto', p: 3 }}>
            <Typography variant="h6" gutterBottom>General Info</Typography>
            <Card variant="outlined" sx={{ mb: 3 }}>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                                <Select
                                    value={info.preferredRegion}
                                    onChange={handleChange('preferredRegion')}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>Select Preferred Working Region</MenuItem>
                                    {allRegion.map((region) => (
                                        <MenuItem key={region} value={region}>
                                            {region.replace(/_/g, ' ').toUpperCase()}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                                <Select
                                    value={info.driverType}
                                    onChange={handleChange('driverType')}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>Select Driver Type</MenuItem>
                                    {allDriverType.map((type) => (
                                        <MenuItem key={type} value={type}>
                                            {type.replace(/_/g, ' ').toUpperCase()}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={info.fastApproved}
                                        onChange={handleChange('fastApproved')}
                                    />
                                }
                                label="Are you FAST approved?"
                            />
                        </Grid>
                        {info.fastApproved && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        fullWidth
                                        label="FAST Number"
                                        value={info.fastNumber}
                                        onChange={handleChange('fastNumber')}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="FAST Expiration"
                                            value={info.fastExpiration}
                                            onChange={handleDateChange}
                                            renderInput={(params) => <TextField {...params} fullWidth required />}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            </>
                        )}
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={info.crossBorderDriving}
                                        onChange={handleChange('crossBorderDriving')}
                                    />
                                }
                                label="Can you legally travel across Canada/USA border?"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={info.bondedDriver}
                                        onChange={handleChange('bondedDriver')}
                                    />
                                }
                                label="Have you ever been bonded?"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                                <Select
                                    value={info.countryOfCitizenship}
                                    onChange={handleChange('countryOfCitizenship')}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>Select Country of Citizenship</MenuItem>
                                    {allCountries.map((country) => (
                                        <MenuItem key={country} value={country}>
                                            {country}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                                <Select
                                    value={info.countryOfResidence}
                                    onChange={handleChange('countryOfResidence')}
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled>Select Country of Residence</MenuItem>
                                    {northAmericaCountries.map((country) => (
                                        <MenuItem key={country} value={country}>
                                            {country}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="Referred By (current/former employee)"
                                value={info.referredBy}
                                onChange={handleChange('referredBy')}
                            />
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <Box sx={{ mt: 3 }}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={handleSubmit}
                >
                    Continue
                </Button>
            </Box>
        </Box>
    );
}

export default GeneralInfo;
